import React from 'react';
import { Box, Button, Grid } from '@mui/material';
import styles from './styles';
import { COLOR_GREY_200, COLOR_PRIMARY_2, COLOR_TEXT_1 } from 'src/utils/colors';
import ArrowRightAltRoundedIcon from '@mui/icons-material/ArrowRightAltRounded';
import { FormData } from 'src/interfaces/iproptypes';

const Navbar = ({
  pageIndex,
  setPageIndex,
  maxPageIndex,
  handleSubmit,
  formData,
}: {
  pageIndex: number;
  setPageIndex: (index: number) => void;
  maxPageIndex: number;
  handleSubmit: () => void;
  formData: FormData;
}) => {
  const increasePageIndex = () => {
    setPageIndex(pageIndex + 1);
  };

  const decreasePageIndex = () => {
    setPageIndex(pageIndex - 1);
  };

  const isLastIndex = pageIndex === maxPageIndex;

  return (
    <Box
      sx={{
        ...styles.contentBox,
        minHeight: '60px',
        height: 'auto',
        borderTop: '1px solid #E0E0E0',
      }}
    >
      <Grid container spacing={2} justifyContent="space-between" alignItems="center">
        <Grid item>
          <Button
            disabled={pageIndex === 0}
            onClick={decreasePageIndex}
            sx={{ color: COLOR_TEXT_1 }}
          >
            Back
          </Button>
        </Grid>
        <Grid
          container
          item
          alignItems="center"
          justifyContent="flex-end"
          sx={{ maxWidth: '200px' }}
        >
          {!isLastIndex && (
            <Grid item>
              <Button
                onClick={increasePageIndex}
                sx={{ color: COLOR_TEXT_1 }}
                disabled={isLastIndex}
              >
                Skip
              </Button>
            </Grid>
          )}
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              endIcon={<ArrowRightAltRoundedIcon />}
              sx={{
                borderRadius: '900px',
                color: '#fff',
                backgroundColor: COLOR_PRIMARY_2,
              }}
              onClick={isLastIndex ? handleSubmit : increasePageIndex}
              disabled={
                isLastIndex &&
                (!formData.firstName ||
                  !formData.email ||
                  !formData.phone ||
                  formData.phone.length < 10)
              }
            >
              {isLastIndex ? 'Submit' : 'Next'}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Navbar;
